export const Actions = {
  ON_RESET_STATE: "ON_RESET_STATE",
  GET_INFRA_TYPE: "GET_INFRA_TYPE",
};
